const draftMutationKeys = {
  updatePipelineStage: ['draft', 'update-pipeline-stage'] as const,
  updatePipeline: ['draft', 'update-pipeline'] as const,
  reorderPipelineStage: ['draft', 'reorder-pipeline-stage'] as const,
  deletePipelineStage: ['draft', 'delete-pipeline-stage'] as const,
  addStageToPipeline: ['draft', 'add-stage-to-pipeline'] as const,
  createAutomation: ['draft', 'create-automation'] as const,
  deleteAutomation: ['draft', 'delete-automation'] as const,
};

export default draftMutationKeys;
